export const GAME_SEARCH_LIST_VARIANT = 'small-compact-grid'
export const GAME_SEARCH_BACKGROUND_COLOR = 'grey-0'
